module.exports = __webpack_public_path__ + "img/well_member_bg.98bf78c4.png";